import { useTranslation } from 'react-i18next'

import { APPLICANT_STAGES } from '../../../../RentalPortalApplicant'
import { Status } from '../../../../Status'

import * as styles from './ViewingFormApplicantOptionStage.module.css'

function ViewingFormApplicantOptionStage({
  className = styles.ViewingFormApplicantOptionStage,
  value,
}) {
  const { t } = useTranslation()

  const stageStatus = APPLICANT_STAGES[value.stage]

  return stageStatus ? (
    <Status
      className={className}
      text={t(stageStatus.text)}
      textColor={stageStatus.textColor}
    />
  ) : null
}

export default ViewingFormApplicantOptionStage
